import { useAuthStore, type AuthUser, type TenantContext } from '@/stores/auth-store';
import { authApi, type TokensPayload } from './api';

/**
 * Finish a successful login: stash tokens, then call /me to populate the
 * principal so role/permission-gated UI has data immediately.
 */
export async function finalizeTokens(tokens: TokensPayload): Promise<void> {
  useAuthStore.setState({
    accessToken: tokens.access_token,
    refreshToken: tokens.refresh_token,
    isAuthenticated: true,
  });
  const me = await authApi.me();
  const user: AuthUser = {
    userId: me.user_id,
    email: me.email,
    fullName: me.full_name,
  };
  const tenant: TenantContext = {
    tenantId: me.tenant_id,
    tenantName: me.tenant_name,
    role: me.role,
    permissions: me.permissions,
  };
  useAuthStore.getState().setSession({
    accessToken: tokens.access_token,
    refreshToken: tokens.refresh_token,
    user,
    tenant,
  });
}
